




























import { computed, defineComponent, onMounted, ref } from '@vue/composition-api';
import { useFieldsView } from '@/store/modules/fieldsView';
import { useGroups } from '@/store/modules/group';
import { useAllResources } from '@/store/modules/resources';
import FieldsList from './FieldsList/FieldsList.vue';
import FieldsListSheet, { FieldsListSheetProps } from './FieldsList/FieldsListSheet.vue';
import FieldsTable from './FieldsTable/FieldsTable.vue';
import FieldsViewControls from './FieldsViewControls/FieldsViewControls.vue';
import FieldsViewMap from './FieldsViewMap/FieldsViewMap.vue';

export default defineComponent({
	components: {
		FieldsViewMap,
		FieldsViewControls,
		FieldsTable,
		FieldsList,
		FieldsListSheet,
	},
	setup(_, { root }) {
		const sheetRef = ref<FieldsListSheetProps | null>(null);
		const { isLoaded: areResourcesLoaded, isLoading: areResourcesLoading } = useAllResources(root.$store);
		const { isLoaded: areGroupsLoaded, isLoading: areGroupsLoading } = useGroups(root.$store);
		const { setFiltersFromUrl } = useFieldsView(root.$store);
		const isLoading = computed(() => areGroupsLoading.value || areResourcesLoading.value);
		const isLoaded = computed(() => areGroupsLoaded.value && areResourcesLoaded.value);

		const collapseSheet = () => {
			sheetRef.value?.collapse();
		};

		onMounted(() => {
			setFiltersFromUrl();
		});

		return {
			isLoaded,
			isLoading,
			sheetRef,
			collapseSheet,
		};
	},
});
